"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_web_components_1 = require("@nimles/react-web-components");

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_redux_2 = require("@nimles/react-redux");

var Link_1 = require("./Link");

var Name = styled_1.default.h2(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 16px;\n  margin-top: 0;\n  font-size: 500;\n  flex: 1 0 auto;\n"], ["\n  font-size: 16px;\n  margin-top: 0;\n  font-size: 500;\n  flex: 1 0 auto;\n"])));
var CardLink = styled_1.default(Link_1.NavLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n"], ["\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n"])));
var InheritLink = styled_1.default(Link_1.NavLink)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: inherit;\n"], ["\n  color: inherit;\n"])));

exports.PageList = function (_a) {
  var organizationId = _a.organizationId,
      start = _a.start,
      limit = _a.limit,
      order = _a.order,
      style = _a.style,
      includeFirstPage = _a.includeFirstPage;
  var dispatch = react_redux_1.useDispatch();
  var pages = react_redux_1.useSelector(function (_a) {
    var publicPages = _a.publicPages;
    return publicPages.values;
  });
  react_1.useEffect(function () {
    dispatch(react_redux_2.loadPublicPages({
      start: start,
      limit: limit,
      order: order,
      organizationId: organizationId
    }));
  }, [start, limit, order, organizationId]);

  if (!includeFirstPage) {
    pages = pages.filter(function (p) {
      return p.pageType !== 'FirstPage';
    });
  }

  style = style && style.toLowerCase();

  switch (style) {
    case 'cards':
      return react_1.default.createElement(react_web_components_1.Row, {
        wrap: true
      }, pages.map(function (page) {
        return react_1.default.createElement(react_web_components_1.Column, {
          key: page.id,
          padding: true,
          xs: 100
        }, react_1.default.createElement(react_web_components_1.Card, {
          flex: "1 0 auto"
        }, react_1.default.createElement(CardLink, {
          to: "/" + page.uniqueName + "/pt"
        }, react_1.default.createElement(react_web_components_1.CardBody, null, react_1.default.createElement(Name, null, page.title)))));
      }));

    case 'list':
      return react_1.default.createElement(react_web_components_1.List, null, pages.map(function (page) {
        return react_1.default.createElement(react_web_components_1.ListItem, {
          key: page.id
        }, react_1.default.createElement(Link_1.NavLink, {
          to: "/" + page.uniqueName + "/pt"
        }, page.title));
      }));

    case 'menu':
      return react_1.default.createElement(react_web_components_1.List, null, pages.map(function (page) {
        return react_1.default.createElement(react_web_components_1.ListItem, {
          key: page.id,
          inheritColors: true
        }, react_1.default.createElement(InheritLink, {
          to: "/" + page.uniqueName + "/pt"
        }, page.title));
      }));

    default:
      return react_1.default.createElement(react_web_components_1.List, null, pages.map(function (page) {
        return react_1.default.createElement(react_web_components_1.ListItem, {
          key: page.id
        }, react_1.default.createElement(Link_1.NavLink, {
          to: "/" + page.uniqueName + "/pt"
        }, page.title));
      }));
  }
};

var templateObject_1, templateObject_2, templateObject_3;